<template>
  <v-container fluid>
    <Resource
      :create-form-component="() => import('../components/forms/Organisation.vue')"
      :meta="{name: 'organisatie', namePlural: 'organisaties'}"
      :table-content="tableContent"
      :update-form-component="() => import('../components/forms/Organisation.vue')"
      resource-uri="organisation"
      can-search
    />
  </v-container>
</template>
<script>
import Resource from '@/components/Resource.vue';

export default {
  components: {Resource},
  name: 'OrganisationResource',
  data() {
    return {
      tableContent: [
        {
          text: 'Naam',
          align: 'left',
          sortable: true,
          value: 'name',
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
